import { render, staticRenderFns } from "./ManageRequestStatuses.vue?vue&type=template&id=a9af7d3c"
import script from "./ManageRequestStatuses.vue?vue&type=script&lang=js"
export * from "./ManageRequestStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports